import { useRouter } from 'next/router';
import { detectLocale } from '@/utils/locale';

const TITLE = {
  cs: 'Chyba načítání stránky',
  pl: 'Błąd ładowania strony'
};

const Page500 = ({ error }) => {
  const router = useRouter();
  const { locale } = detectLocale(router.asPath || '/');

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="mb-4 text-2xl font-bold">{locale !== 'pl' ? TITLE.cs : TITLE.pl}</h1>
        <p className="text-gray-600">{error}</p>
      </div>
    </div>
  );
};
export default Page500;
